import 'lightgallery.js'

class FaqMediaGallery {
  constructor() {
    this.selector = '.faq-media-carousel'
  }

  init() {
    $(this.selector).each((index, carousel) => {
      window.lightGallery(carousel, {
        selector: '.carousel-item[data-src]',
        mode: 'lg-fade',
        download: false,
      })
    })
  }
}

export default FaqMediaGallery
